const EmailLarge = () => {
  return (
    <svg width="80" height="80" viewBox="7 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_diii_28329_194957)">
        <g clipPath="url(#clip0_28329_194957)">
          <rect x="8" y="4.57141" width="64" height="64" rx="32" fill="#225AEA" />
          <rect
            x="8"
            y="4.57141"
            width="64"
            height="64"
            rx="32"
            fill="url(#paint0_linear_28329_194957)"
          />
          <g opacity="0.4">
            <path
              d="M32.7021 13.249C32.3357 11.8842 30.9261 11.0618 29.6045 11.5626C23.61 13.831 18.6844 18.2656 15.8013 23.9898C15.1645 25.2538 15.8349 26.7418 17.1549 27.2474C18.4749 27.7546 19.9421 27.0858 20.6109 25.8394C22.8641 21.63 26.5173 18.3402 30.9389 16.5386C32.2493 16.0042 33.0669 14.6154 32.7021 13.2506V13.249Z"
              fill="#F2F6FF"
            />
          </g>
          <path
            d="M28.5708 28.5714C28.5708 27.9403 29.0825 27.4286 29.7137 27.4286H50.2851C50.9163 27.4286 51.4279 27.9403 51.4279 28.5714V30.7223L39.9994 36.4366L28.5708 30.7223V28.5714Z"
            fill="white"
          />
          <path
            d="M28.5708 33.2778V44.5714C28.5708 45.2026 29.0825 45.7143 29.7137 45.7143H50.2851C50.9163 45.7143 51.4279 45.2026 51.4279 44.5714V33.2778L40.5105 38.7365C40.1887 38.8974 39.81 38.8974 39.4883 38.7365L28.5708 33.2778Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_diii_28329_194957"
          x="-9.53674e-07"
          y="-1.7143"
          width="80"
          height="81.7143"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.42857" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_28329_194957"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_28329_194957"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-2.85714" dy="-2.85714" />
          <feGaussianBlur stdDeviation="1.14286" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_28329_194957" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="0.571429"
            operator="erode"
            in="SourceAlpha"
            result="effect3_innerShadow_28329_194957"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1.14286" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.113725 0 0 0 0 0.309804 0 0 0 0 0.843137 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_28329_194957"
            result="effect3_innerShadow_28329_194957"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-6.28571" />
          <feGaussianBlur stdDeviation="3.14286" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.94902 0 0 0 0 0.968627 0 0 0 0 1 0 0 0 0.35 0"
          />
          <feBlend
            mode="normal"
            in2="effect3_innerShadow_28329_194957"
            result="effect4_innerShadow_28329_194957"
          />
        </filter>
        <linearGradient
          id="paint0_linear_28329_194957"
          x1="40"
          y1="4.57141"
          x2="40"
          y2="68.5714"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.16" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0_28329_194957">
          <rect x="8" y="4.57141" width="64" height="64" rx="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default EmailLarge
